import { render } from "./ModalNoticiaAgregar.vue?vue&type=template&id=3a50c12b&scoped=true"
import script from "./ModalNoticiaAgregar.vue?vue&type=script&lang=js"
export * from "./ModalNoticiaAgregar.vue?vue&type=script&lang=js"

import "@/assets/styles/modal-styles.css?vue&type=style&index=0&id=3a50c12b&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a50c12b"]])

export default __exports__